import { CaptureProfile, ELightPath, ImagingCaptureProfile } from "../Model/CaptureProfile";
import { Collection } from "../Model/Collection";

class CaptureProfileUtil {
  static convertToCaptureProfileCollection(
    captureProfiles: ImagingCaptureProfile[]
  ): Collection<ImagingCaptureProfile> {
    console.log(captureProfiles);
    let byId: { [index: string]: ImagingCaptureProfile } = {};
    let allIds: string[] = [];
    for (let captureProfile of captureProfiles) {
      allIds.push(captureProfile.captureProfileId);
      byId[captureProfile.captureProfileId] = captureProfile;
    }
    const captureProfileCollection = {
      allIds: allIds,
      byId: byId,
    };

    return captureProfileCollection;
  }

  static getTotalZoom(captureProfile: CaptureProfile, lightPath: ELightPath) {
    let realZoom = 1;
    let cropZoom = 1;
    switch (lightPath) {
      case ELightPath.Fluorescence: {
        cropZoom = captureProfile.fluorescence?.cropZoom ?? 1;
        realZoom = captureProfile.fluorescence?.objectiveZoom ?? 1;
        break;
      }
      case ELightPath.Ultraviolet: {
        cropZoom = captureProfile.ultraviolet?.cropZoom ?? 1;
        realZoom = captureProfile.ultraviolet?.objectiveZoom ?? 1;
        break;
      }
      case ELightPath.Visible: {
        cropZoom = captureProfile.visible?.cropZoom ?? 1;
        realZoom = captureProfile.visible?.objectiveZoom ?? 1;
        realZoom = captureProfile.visible?.continuousZoom ?? realZoom;
        break;
      }
      default: {
        throw new Error(`LightPath ${ELightPath[lightPath]} is not supported`);
      }
    }

    return realZoom * cropZoom;
  }

  static getHardwareZoom(captureProfile: CaptureProfile, lightPath: ELightPath) {
    let realZoom = 1;
    switch (lightPath) {
      case ELightPath.Fluorescence: {
        realZoom = captureProfile.fluorescence?.objectiveZoom ?? 1;
        break;
      }
      case ELightPath.Ultraviolet: {
        realZoom = captureProfile.ultraviolet?.objectiveZoom ?? 1;
        break;
      }
      case ELightPath.Visible: {
        realZoom = captureProfile.visible?.objectiveZoom ?? 1;
        realZoom = captureProfile.visible?.continuousZoom ?? realZoom;
        break;
      }
      default: {
        throw new Error(`LightPath ${ELightPath[lightPath]} is not supported`);
      }
    }

    return realZoom;
  }

  static getBinning(captureProfile: CaptureProfile, lightPath: ELightPath) {
    let binning = 1;
    switch (lightPath) {
      case ELightPath.Fluorescence: {
        binning = captureProfile.fluorescence?.binning ?? 1;
        break;
      }
      case ELightPath.Ultraviolet: {
        binning = captureProfile.ultraviolet?.binning ?? 1;
        break;
      }
      case ELightPath.Visible: {
        binning = captureProfile.visible?.binning ?? 1;
        break;
      }
      default: {
        throw new Error(`LightPath ${ELightPath[lightPath]} is not supported`);
      }
    }

    return binning;
  }
}

export default CaptureProfileUtil;

// export function validateCaptureProfileByLightPathCapability(
//   lightPathCapability: LightPathCapability,
//   captureProfile: CaptureProfile,
//   lightPath: ELightPath
// ): Result<boolean> {

// }

// function validateVisibleCaptureProfileByLightPathCapability(
//   lightPathCapability: LightPathCapability,
//   visibleCaptureProperty: VisibleCaptureProperty,
// ): Result<boolean> {

//   if(visibleCaptureProperty.)

// }
